export const poundsToPences = (price) => {
  if (typeof price === 'number') {
    return price * 100;
  }
  return null;
};
